import 'whatwg-fetch';
import { CMS_DATA_RECEIVED } from './actionTypes/';
/**
 * @description CMS page data recived
 * @param {Object} message
 * @param {String} key 
 * @returns {Object} New state
 */
export const CmsDataReceived = (message, key) => {
    return {
        type: CMS_DATA_RECEIVED,
        payload: message,
        key
    };
};